import React, { useContext, useEffect } from 'react';
import { Checkbox } from 'antd';
import { ModelContext } from '../../metadata/ModelSource';
import {DriversAndVehiclesDataReportContext} from '../../../context/DriversAndVehiclesDataReportProvider';
const CheckboxGroup = Checkbox.Group;

export function DriversCheckbox({ defaultValue, onChange, formAttribute }) {
  const applicationModel = useContext(ModelContext);
  const { selectedDrivers, dataPrefillDrivers, setSelectedDrivers, setDataPrefillDrivers } = useContext(DriversAndVehiclesDataReportContext);

  let drivers = applicationModel.getValue(formAttribute) || [];

  useEffect(() => {
    let prefillDrivers = drivers.filter(d=>d.id.indexOf('Prefill') !== -1);
    prefillDrivers = prefillDrivers.map(d=> ({...d, 'status' : 'Prefill'}));

    setDataPrefillDrivers(prefillDrivers);
  }, [applicationModel]);



  const onDriversChange = selectedValues => {
    //get the drivers that were selected
    drivers = drivers.map(d=>{
      if(selectedValues.includes(d.id)){
        return {...d,'status': 'Active'};
      }else {
        return {...d,'status': 'Deleted'};
      }
    })

    let selected = drivers.filter(d=>selectedValues.includes(d.id))
    setSelectedDrivers(selected);

    applicationModel.setValue(formAttribute,drivers)
  };

  return (
      dataPrefillDrivers && dataPrefillDrivers.length > 0 ? <CheckboxGroup
          style={{marginBottom:'1em',display:"flex", flexDirection:"column"}}
          onChange={onDriversChange}
          options={dataPrefillDrivers.map((d) => ({label:d.nameInfo.givenName+" "+d.nameInfo.surname,value:d.id}))}
          defaultValue={selectedDrivers ? selectedDrivers.map(d=>d.id): []}
      >
      </CheckboxGroup> : null
  );
}
